import { useState } from "react";
import saveIcon from "../assets/save-icon.svg";

const QUESTIONNAIRE_DATA = [
  {
    id: 1,
    description: "Is the MRI report submitted ?",
  },
  {
    id: 2,
    description:
      "Routine Biochemistry Haemogram Urea Creatinine Electrolytes Sugar Fasting Lipids Liver Function Test Urinalysis",
  },
  {
    id: 3,
    description: "Coronary Angiography Stills Showing Blockage",
  },
  {
    id: 4,
    description: "Number of Stents Used In 3",
  },
  {
    id: 5,
    description: "2d Echo",
  },
  {
    id: 6,
    description: "Barcode of All Stents Bare Metal Drug Eluting Available",
  },
  {
    id: 7,
    description: "Consent Duly Signed By Patient Treating Cardiologist",
  },
  {
    id: 8,
    description:
      "If Bare Metal Stent Used Is The Artery Diameter 3 5 Mm Legion Length 18mm Patient Is Non Diabetic",
  },
  {
    id: 9,
    description: "Reasons Justification If Multiple Stents Used",
  },
  {
    id: 10,
    description: "Clinical Notes",
  },
];

const STGQuestionnaireFormAi = () => {
  const [answers, setAnswers] = useState({});

  const handleAnswer = (id, value) => {
    setAnswers((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  return (
    <div className="w-full">
      <div className="w-full h-0 border border-solid border-[#00000010] bg-[#00000010]" />{" "}
      <div className="pt-[30px]">
        <div className="grid grid-cols-[50px_1.2fr_180px] gap-x-[50px] items-start">
          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            No.
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] text-[#5AC69F]">
            Description
          </div>

          <div className="font-lufga font-normal text-[14px] leading-[12px] pl-6 tracking-[-0.03em] text-[#5AC69F] ml-16">
            Action
          </div>
        </div>

        <div className="mt-[34px] flex flex-col gap-y-[34px]">
          {QUESTIONNAIRE_DATA.map((item) => (
            <div
              key={item.id}
              className="grid grid-cols-[50px_1fr_180px] gap-x-[50px] items-start"
            >
              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.id}.
              </div>

              <div className="font-lufga font-normal text-[14px] leading-[100%] tracking-[-0.03em] text-[#000000]">
                {item.description}
              </div>

              <div className="flex items-center gap-[8px] justify-self-end">
                <button
                  type="button"
                  onClick={() => handleAnswer(item.id, "YES")}
                  className={`w-[66px] h-[41px] rounded-[100px] border border-none flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] ${
                    answers[item.id] === "YES"
                      ? "bg-[#5AC69F] text-white"
                      : "bg-[#F5F5F5] text-[#000000]"
                  }`}
                >
                  Yes
                </button>
                <button
                  type="button"
                  onClick={() => handleAnswer(item.id, "NO")}
                  className={`w-[66px] h-[41px] rounded-[100px] border border-none flex justify-center items-center font-lufga font-normal text-[14px] leading-[12px] tracking-[-0.03em] ${
                    answers[item.id] === "NO"
                      ? "bg-[#FF4343] text-white"
                      : "bg-[#F5F5F5] text-[#000000]"
                  }`}
                >
                  No
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="flex justify-end mt-[12px]">
        <button className="w-[170px] h-[74px] xl:w-[94.97px] xl:h-[40.97px]  2xl:w-[94.97px] 2xl:h-[40.97px] border border-none rounded-full bg-black flex justify-center items-center gap-[8px] font-lufga text-[14px] text-[#68FF9F] font-normal">
          SAVE
          <img src={saveIcon} alt="save" className="pl-[16px]" />
        </button>
      </div>
    </div>
  );
};

export default STGQuestionnaireFormAi;
